import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
var state = sessionStorage.getItem('state') ? JSON.parse(sessionStorage.getItem('state')) : { // 防止刷新后数据丢失
  gameID: 0,  //游戏id
  gameName: '', //游戏名称
  aid: '',  // 用户id
  pin: '',
  icon: '',
  serviceMail: '',
  canCancel: false,  //可以取消
  taskExist: false,  //是否已经创建过删除任务
  dataExist: false,  //是否已经创建过数据请求任务
  pendFlag: false,  //是否还在准备数据中
  lastCancelTime: 0,  //最后可以取消的时间
  requestState: 0,
  requestDataState: 0,
  autoLogined: false // 客户端内自动登录
}
export default new Vuex.Store({
  state: state,
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
